import { createBrowserHistory } from 'history';
import config from '../../util/config';
const history = createBrowserHistory({
  basename: `/${config.loginAppBasePath || 'login'}`,
});
export default history;
